import dayjs from "dayjs";

interface ActiveContactsRecord {
  date: string;
  count: number;
}

/**
 * The latest 30-day active contact count and, when the snapshot from 30 days
 * before it exists, the change since then. Each daily record already counts
 * the unique contacts active in the 30 days ending on its date.
 */
export const summarizeActiveContacts = (
  records: ReadonlyArray<ActiveContactsRecord>,
): { date: string; count: number; change: number | null } | null => {
  const latest = records.reduce<ActiveContactsRecord | null>(
    (found, record) => (!found || record.date > found.date ? record : found),
    null,
  );
  if (!latest) return null;
  const previousDate = dayjs(latest.date)
    .subtract(30, "day")
    .format("YYYY-MM-DD");
  const previous = records.find((record) => record.date === previousDate);
  return {
    date: latest.date,
    count: latest.count,
    change: previous ? latest.count - previous.count : null,
  };
};
